<template>
  <filter-dropdown
    label="Group By"
    @change="$emit('group', $event)"
    :options="groups"
    :selected="selected"
  >
  </filter-dropdown>
</template>

<script>
import FilterDropdown from '@/components/FilterDropdown'
import { CUSTOM_FIELD_TYPE } from '@/constants/customFields'
import {
  BOARD_GROUP_TYPE,
  CF_PREFIX,
  GROUP_BY_NONE_ID,
  GROUP_BY_SECTION_ID,
  INITIATIVE_FIELDS
} from '@/constants/initiative'

/**
 * This gives a dropdown to select groupBy parameter
 */
export default {
  name: 'GroupByDropdown',
  props: ['groupBy', 'orgId', 'includeSectionsGrouping'],
  components: {
    FilterDropdown
  },
  computed: {
    selected() {
      return this.groups.find(grp => grp.id === this.groupBy)?.label
    },
    groups() {
      const initiativeFields = [
        this.includeSectionsGrouping
          ? { id: GROUP_BY_SECTION_ID, label: 'Section' }
          : { id: GROUP_BY_NONE_ID, label: 'None' },
        INITIATIVE_FIELDS.STATUS,
        INITIATIVE_FIELDS.IMPACT,
        INITIATIVE_FIELDS.OWNER
      ]
      const customFieldsDefinitions = this.$store.getters
        .customFieldDefinitions(Number(this.orgId))
        .filter(def => [CUSTOM_FIELD_TYPE.USER, CUSTOM_FIELD_TYPE.DROPDOWN].includes(def.type))
      customFieldsDefinitions.forEach(def => {
        initiativeFields.push({
          id: CF_PREFIX + def.id,
          label: def.name,
          type: BOARD_GROUP_TYPE.CUSTOM_FIELD
        })
      })
      return initiativeFields
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
